import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { LmsService } from './services/lms.service';
import { Observable, catchError, map, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TranslateHttpLoader implements TranslateLoader {

    constructor(private lmsService: LmsService, private http: HttpClient) { }

    getTranslation(lang: string): Observable<Record<string, string>> {
        return this.lmsService.loadTranslations(lang).pipe(
            map(translationMap => Object.fromEntries(translationMap) as Record<string, string>),
            catchError(() => {
                return this.loadLocalTranslations(lang);
            })
        );
    }

    loadLocalTranslations(lang: string): Observable<Record<string, string>> {
        return this.http.get<Record<string, string>>(`/assets/i18n/${lang}.json`).pipe(
            catchError(() => {
                return of({});
            })
        );
    }
}